import * as Store from './store';

export const practiceModules = [
  Store.practiceStoreContainerModule
]
